import { useState } from "react";
import { Modal } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";
import Check from './Check'
import VeryfyCode from './VeryfyCode'
import UserLogin from './UserLogin'
import ForgetPassword from './ForgetPassword'
import Signup from "./Signup";

const AuthModal = ({ show, setShow }) => {
    const [showCheck, setShowCheck] = useState(true);
    const [showLogin, setShowLogin] = useState(false);
    const [showSignup, setShowSignup] = useState(false);
    const [showVerify, setShowVerify] = useState({
        status: false,
        mobile: null
    });
    const [showFroget, setShowFroget] = useState(false);

    return (
        <div className="modalLogin">
            <Modal
                show={show}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Body>
                    <span className="closeBtn" onClick={() => setShow(false)}>
                        <BsXLg />
                    </span>
                    <div className="px-3 my-3">
                        {showCheck && <Check isModal={true} setShowSignup={setShowSignup} setShowLogin={setShowLogin} setShowCheck={setShowCheck} />}
                        {showSignup && <Signup setShowModalLogin={setShow} setShowVerify={setShowVerify} isModal={true} setShowSignup={setShowSignup} setShowLogin={setShowLogin} />}
                        {showVerify.status && <VeryfyCode isModal={true} mobileData={showVerify.mobile} setShowModalLogin={setShow} setShowVerify={setShowVerify} setShowLogin={setShowLogin} />}
                        {showLogin && <UserLogin setShowFroget={setShowFroget} setShowModalLogin={setShow} isModal={true} setShowSignup={setShowSignup} setShowLogin={setShowLogin} />}
                        {showFroget && <ForgetPassword isModal={true} setShowModalLogin={setShow} />}
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    )
}
export default AuthModal;